<template>
  <component
    :is="tag"
    :to="to"
    :class="classes"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'Card',
  props: {
    tag: { type: String, default: 'div' },
    to: { type: String, default: undefined },
    square: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
  },
  setup(props) {
    const classes = computed(
      () =>
        'card' +
        (props.bordered === true ? ' card--color-bordered' : '') +
        (props.square === true ? ' card--square' : '') +
        (props.flat === true ? ' card--flat' : ''),
    )

    return {
      classes,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/spacings.scss';
@import '@/uiKit/assets/fonts.scss';
@import '@/uiKit/assets/borders.scss';
@import '@/uiKit/assets/colors.scss';
@import '@/uiKit/assets/shadows.scss';

.card {
  box-shadow: $effectShadowsXXS;
  border-radius: $borderRadius12;
  background: $colorNeutralsWhite;
  position: relative;
  background-color: var(--color-surface-default);
  @include col;

  &.card--color-bordered {
    border: 1px solid var(--color-border-default);
  }

  &.card--square {
    border-radius: $borderRadius0;
  }

  &.card--flat {
    box-shadow: none;
  }
}
</style>
